import { styled } from '@mui/system'

export const Label = styled('label')`
    margin-bottom: 1px;
    display: block;
    font-size: 14px;
    font-weight: 500;
`
